import React, { isValidElement } from "react";
import { SwipeableDrawer, Box, Typography, Stack } from "@mui/material";
import { create } from "zustand";
import { ButtonClose } from "../components/buttons/button-close";
export const useAppSwipeableDrawer = create((set, get) => ({
  open: false,
  content: "",
  locked: false,
  title: "",
  args: {},
  setOpen: (open) => set({ open }),
  closeDrawer: (unlock = null) =>
    set({ open: false, locked: unlock ? false : get().locked }),
  setContent: (content) => set({ content }),
  lockDrawer: (locked) => set({ locked }),
  invokeSwipeableDrawer: (content, args) => {
    // set({ content, open: true, title: args?.title || "" });
    if (!isValidElement(content) && (typeof content === 'function')) {
      return new Promise((resolve, reject) => {
        const close = args?.close;
        args.close = () => {
          reject();
          close && close();
        }
        const onResolve = () => resolve();
        const onReject = () => reject();
        set({ content: content(onResolve, onReject, () => { reject(); get().closeDrawer(); }), title: args?.title || "", args, open: true });
      });
    }
    return set({ content, args, open: true, title: args?.title || "", });
  },
}));

const BottomSwipeableDrawer = () => {
  const { open, setOpen, content, title } = useAppSwipeableDrawer();
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      swipeAreaWidth={open ? 20 : 0} // Imposta la larghezza dell'area swipe basata sullo stato del drawer
      disableSwipeToOpen={!open} // Disabilita lo swipe per aprire se il drawer non è aperto
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={(theme) => ({
        "& .MuiDrawer-paper": {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          height: "auto",
          maxHeight: "70vh", // Limita l'altezza massima del drawer
          position: "fixed", // Usa 'fixed' per ancorare il drawer in basso
          bottom: 0, // Ancorare il drawer al fondo dello schermo
          width: "100%", // Imposta la larghezza al 100% dello schermo
          zIndex: theme.zIndex.swipeableDrawer, // Usa lo zIndex del tema
        },
      })}>
      <Box sx={{ padding: 2 }}>
        <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'space-between'}>
          <Typography variant="h6" sx={{ lineHeight: 1.2 }}>{title}</Typography>
          <ButtonClose onClick={toggleDrawer(false)} />
        </Stack>
        {content}
      </Box>
    </SwipeableDrawer>
  );
};

export default BottomSwipeableDrawer;
